// extracted by mini-css-extract-plugin
export default {"container":"CreativesTableView_container__V5xs5","table":"CreativesTableView_table__a5sFw"};